/**
 * Device Detection Utilities
 * Screen size and device type detection
 */

/**
 * Check Client is Mobile or Not
 * @returns {boolean}
 */
export function isMobile() {
  const clientWidth =
    document.documentElement.clientWidth || document.body.clientWidth;
  return clientWidth < 992;
}

/**
 * Check Client is Tablet or Not
 * @returns {boolean}
 */
export function isTablet() {
  const clientWidth =
    document.documentElement.clientWidth || document.body.clientWidth;
  return clientWidth >= 992 && clientWidth < 1100;
}

/**
 * Check Client is Desktop
 * @returns {boolean}
 */
export function isDesktop() {
  const clientWidth =
    document.documentElement.clientWidth || document.body.clientWidth;
  return clientWidth >= 1100;
}

/**
 * Get screen width
 * @returns {number}
 */
export function getScreenWidth() {
  return document.documentElement.clientWidth || document.body.clientWidth;
}

/**
 * Get screen height
 * @returns {number}
 */
export function getScreenHeight() {
  return document.documentElement.clientHeight || document.body.clientHeight;
}

/**
 * Check if device is touch enabled
 * @returns {boolean}
 */
export function isTouchDevice() {
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    navigator.msMaxTouchPoints > 0
  );
}
